import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const PriceQuotesSavedListDocument = gql`
  query PriceQuotesSavedList($businessOrganizationUUID: uuid!) {
    getPriceQuotes(business_organization_id: $businessOrganizationUUID) {
      account_name
      currency_code
      item_count
      name
      price_quote_id
      quote_type
      total_amount_in_micros
      total_savings_in_micros
      updated_at
    }
  }
`;
export function usePriceQuotesSavedListQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >(PriceQuotesSavedListDocument, options);
}
export function usePriceQuotesSavedListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >(PriceQuotesSavedListDocument, options);
}
export type PriceQuotesSavedListQueryHookResult = ReturnType<
  typeof usePriceQuotesSavedListQuery
>;
export type PriceQuotesSavedListLazyQueryHookResult = ReturnType<
  typeof usePriceQuotesSavedListLazyQuery
>;
export type PriceQuotesSavedListQueryResult = Apollo.QueryResult<
  Types.PriceQuotesSavedListQuery,
  Types.PriceQuotesSavedListQueryVariables
>;

/**
 * Wrapped version of useGeneratedPriceQuotesSavedListQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPriceQuotesSavedListQuery(
  options?: Apollo.QueryHookOptions<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >(PriceQuotesSavedListDocument, options);
}

/**
 * Wrapped version of useGeneratedPriceQuotesSavedListLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPriceQuotesSavedListLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PriceQuotesSavedListQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PriceQuotesSavedListQuery,
    Types.PriceQuotesSavedListQueryVariables
  >(PriceQuotesSavedListDocument, lazyOptions);
}
